import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mediaSingleSpec } from '@atlaskit/adf-schema';
import { fg } from '@atlaskit/platform-feature-flags';
import { getAttrsFromNodeMediaSingle } from './toDOMAttrs';
var skeletonStyling = "background: ".concat("var(--ds-background-neutral, #091E420F)", "; outline: none;");
export var wrappedLayouts = ['wrap-left', 'wrap-right', 'align-end', 'align-start'];

/**
 * Duplicate of method from `@atlaskit/editor-common/utils`.
 * `packages/editor/editor-common/src/utils/rich-media-utils.ts`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */
export var shouldAddDefaultWrappedWidth = function shouldAddDefaultWrappedWidth(layout, width, lineLength) {
  return wrappedLayouts.indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
var MEDIA_SINGLE_GUTTER_SIZE = 24;
var DEFAULT_EMBED_CARD_WIDTH = 680;
var akEditorMediaResizeHandlerPaddingWide = 12;

/**
 * Duplicate of method from `@atlaskit/editor-common/media-single`.
 * `packages/editor/editor-common/src/media-single/utils.ts`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */
export function getMediaSinglePixelWidth(width, editorWidth) {
  var widthType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'percentage';
  var gutterOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (widthType === 'pixel') {
    return width;
  }
  return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}

/**
 * Duplicate logic from `@atlaskit/editor-common/ui` for MediaSingle.
 * `packages/editor/editor-common/src/ui/MediaSingle/index.tsx`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */
function computeMediaSingleDimensions(_ref) {
  var childNode = _ref.childNode,
    mediaSingleWidth = _ref.mediaSingleWidth,
    widthType = _ref.widthType,
    editorWidth = _ref.editorWidth;
  var width = childNode === null || childNode === void 0 ? void 0 : childNode.attrs.width;
  var height = childNode === null || childNode === void 0 ? void 0 : childNode.attrs.height;
  if (!mediaSingleWidth && shouldAddDefaultWrappedWidth(childNode === null || childNode === void 0 ? void 0 : childNode.attrs.layout, width, editorWidth)) {
    mediaSingleWidth = widthType === 'pixel' ? editorWidth / 2 : 50;
  }
  var isHeightOnly = width === undefined;
  if (mediaSingleWidth) {
    var pxWidth = getMediaSinglePixelWidth(mediaSingleWidth, editorWidth, widthType, MEDIA_SINGLE_GUTTER_SIZE);
    if (isHeightOnly) {
      return {
        width: pxWidth - akEditorMediaResizeHandlerPaddingWide,
        height: height
      };
    } else {
      return {
        width: pxWidth,
        height: height / width * pxWidth
      };
    }
  } else if (isHeightOnly) {
    return {
      width: DEFAULT_EMBED_CARD_WIDTH - akEditorMediaResizeHandlerPaddingWide,
      height: height
    };
  }
  return {
    height: height,
    width: width
  };
}
function computeLayoutStyles(width, layout) {
  switch (layout) {
    case 'align-end':
      return "margin-left: auto; margin-right: 0; width: ".concat(width, "px;");
    case 'align-start':
      return "margin-left: 0; margin-right: auto; width: ".concat(width, "px;");
    case 'center':
      return 'margin-left: auto; margin-right: auto;';
    case 'full-width':
    case 'wide':
      return 'width: 100%; margin-top: 56px; margin-bottom: 56px;';
    case 'wrap-left':
      return 'float: left;';
    case 'wrap-right':
      return 'float: right;';
  }
}

// @nodeSpecException:toDOM patch
export var mediaSingleSpecWithFixedToDOM = function mediaSingleSpecWithFixedToDOM(mediaSingleOption) {
  var mediaSingleNode = mediaSingleSpec(mediaSingleOption);
  if (!fg('platform_editor_lazy-node-views')) {
    return mediaSingleNode;
  }
  return _objectSpread(_objectSpread({}, mediaSingleNode), {}, {
    toDOM: function toDOM(node, lazyNodeViewOptions) {
      var _mediaSingleAttrs$lay;
      var mediaSingleAttrs = node.attrs;
      var layout = (_mediaSingleAttrs$lay = mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.layout) !== null && _mediaSingleAttrs$lay !== void 0 ? _mediaSingleAttrs$lay : 'center';
      var mediaSingleWidth = mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.width;
      var widthType = mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.widthType;
      var childNode = node.firstChild;
      var dataAttrs = getAttrsFromNodeMediaSingle(mediaSingleOption.withExtendedWidthTypes, node);
      var _computeMediaSingleDi = computeMediaSingleDimensions({
          childNode: childNode,
          widthType: widthType,
          mediaSingleWidth: mediaSingleWidth,
          editorWidth: (lazyNodeViewOptions === null || lazyNodeViewOptions === void 0 ? void 0 : lazyNodeViewOptions.editorLineWidth) || 760
        }),
        width = _computeMediaSingleDi.width,
        height = _computeMediaSingleDi.height;
      var sizes = width && height ? "width: ".concat(width, "px; height: ").concat(height, "px; ").concat(skeletonStyling) : '';
      var layoutStyles = computeLayoutStyles(mediaSingleWidth, layout);
      var style = "display: block; margin-top: ".concat("var(--ds-space-300, 24px)", "; margin-bottom: ", "var(--ds-space-300, 24px)", "; ", layoutStyles);
      var layoutClass = "image-".concat(layout);
      var centerLayout = "display: flex; justify-content: center;";
      var endLayout = "display: flex; justify-content: end;";
      var startLayout = "display: flex; justify-content: start;";
      var layoutStyle = layout === 'align-end' ? endLayout : layout === 'align-start' ? startLayout : centerLayout;
      var content = ['div', _objectSpread({
        class: "rich-media-item mediaSingleView-content-wrap ".concat(layoutClass)
      }, dataAttrs), ['div', {
        // Transparent image workaround to control styling
        style: "".concat(sizes, "; ").concat(style, "; max-width: 100%; border-radius: ", "var(--ds-border-radius, 3px)", "; ").concat(layoutStyle)
      }, ['figure', {
        class: 'media-single-node',
        style: 'margin: 0px'
      }, ['div', {}, ['div', {
        class: 'media-content-wrap'
      }, 0]]]]];
      return ['div', {
        class: 'mediaSingleView-content-wrap',
        layout: layout
      }, content];
    }
  });
};